export const PUSHER_EVENT_PREFIX = 'pusher_';

export const hasPusherPrefix = (eventType?: string): eventType is `pusher_${string}` =>
  typeof eventType === 'string' && eventType.startsWith(PUSHER_EVENT_PREFIX);
